import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon.js";
import { LabelLangString } from "component/LabelLang/label-lang.js";

function PublicationActions({ publication, searchDetails, currentLocale }) {
  const metaDataLink = publication?.hasMetaData
    ? LabelLangString({
        id: "metaDataLink",
        currentLocale,
        defaultValue: publication?.metaDataLink,
        translations: publication?.publicationTranslations,
      })
    : null;

  return (
    <div className="col-lg-4">
      {publication?.hasData &&
        publication?.subject?.mainSubjectId &&
        publication?.subject?.id && (
          <>
            <Link
              to={`/data/mainSubject/${publication.subject.mainSubjectId}/subSubject/${publication.subject.id}`}
              className="main-btn mie"
            >
              <span>
                <FormattedMessage id="info-publication" />{" "}
                <ChevronIcon width={20} height={10} />
              </span>
            </Link>
            <br />
          </>
        )}

      {publication?.hasMetaData && (
        <>
          {metaDataLink ? (
            <Link to={metaDataLink} className="main-btn">
              <span>
                <FormattedMessage id="metadata" />{" "}
                <ChevronIcon width={20} height={10} />
              </span>
            </Link>
          ) : null}
          <br />
        </>
      )}

      {publication?.hasInfograph && searchDetails?.id && (
        <Link to={`/infograph/${searchDetails.id}`} className="main-btn">
          <span>
            <FormattedMessage id="infographic" />{" "}
            <ChevronIcon width={20} height={10} />
          </span>
        </Link>
      )}
    </div>
  );
}

export default PublicationActions;
